'use client';

import { ImageBj } from '@components/common';
import { cn } from '@utils/cn';
import bestieImage from '@images/bestie/bestie-rocket.png';
import loginImage from '@images/login/login-bg.png';
import newBestieImage from '@images/bestie/bestie.png';

interface Props {
  className?: string;
  variant?: 'default' | 'login' | 'newBestie';
}

const imageMap = {
  default: bestieImage,
  login: loginImage,
  newBestie: newBestieImage,
} as const;

const BestieAvatar = ({ className, variant = 'default' }:Props) => (
  <div className={cn('relative size-32 overflow-hidden rounded-full', className)}>
    <ImageBj
      priority
      src={imageMap[variant]}
      alt="Bestie"
      className="size-full scale-80 object-cover object-top"
    />
  </div>
);

export default BestieAvatar;
